<template>
    <div class="">
        <p class="title sub-title">
            <span>
                <i class="questionIndex"> {{ questionIndex + 1 }}</i>
                <i class="questionTotal">/{{ questionTotal }}</i>
            </span>
            {{ questionData.question }}
            <b class="select-type">({{$t('questionaire.imgTextOptions')}})</b>
            <b v-if="questionData.isOptional == 0" class="must-notice">*</b>
        </p>
        <div class="questionOpts-container" :class="{'content-left':questionData.questionOpts.length == 1}">
            <div class="opts-item" v-for="(item,index) in questionData.questionOpts" :key="index" @click="qaItemSave(index)">
                <img class="img-box" :src="item.imgUrl" alt="">
                <div class="flex-center" :class="{'f1':isEditable, 'f2':!isEditable, 'f1-active':item.isSelected===1&& isEditable, 'f2-active':item.isSelected===1&&!isEditable}" >
                    <div class="circle" style="margin:0">
                    <i :class="[{'active':item.isSelected===1}]" />
                    </div>
                    <span>{{ setabc(index) }}、{{ item.label }}
                    </span>
                </div>
                <p class="img-desc">{{item.explain}}</p>
            </div>
        </div>
    </div>
</template>

<script>
import { generateBig_1 } from '@/utils/generate26Letter'

export default {
    props:{
        isPreview: {
            type: Boolean,
            default: false
        },
        isEditable: {
            type: Boolean,
            default: true
        },
        isAdditional: {
            type: Boolean,
            default: false
        },
        questionData: Object,
        questionIndex: Number,
        questionTotal: Number,
        afterAnswered: Function
    },
    methods:{
        qaItemSave(index) {
            if (!this.isEditable) {
                return
            }
            for (let i = 0; i < this.questionData.questionOpts.length; i++) {
                if (i === index) {
                this.questionData.questionOpts[i].isSelected = 1
                } else {
                this.questionData.questionOpts[i].isSelected = 0
                }
            }
            if(this.questionData.questionOpts[index].additionalQuestions.length == 0){
                this.afterAnswered(this.questionData);
            }
        },
        setabc(index) {
            const ary = generateBig_1()
            return ary[index]
        }
    }
}
</script>

<style lang="less" scoped>
.questionOpts-container{
    overflow: hidden;
    width: max-content;
    margin: 0 auto;
    max-width: 11.3rem;
    .opts-item{
        float: left;
        width: 5rem;
        margin-bottom: 0.4rem;
        &:nth-child(2n){
            margin-left: 1.2rem;
        }
        .flex-center{
            padding-bottom: 0;
        }
        .img-desc{
            height: 0.92rem;
            line-height: 0.92rem;
            font-size: 0.56rem;
            font-family: PingFang SC;
            font-weight: 400;
            color: #666666;
        }
        .img-box{
            width: 4.92rem;
            height: 6.9rem;
            display: block;
            border-radius: 0.16rem;
            margin: 0.1rem 0 0.2rem 0;
        }
    }
}
.questionOpts-container.content-left{
    width: 100%;
}
</style>